import Typography, { TypographyProps } from '@mui/material/Typography';
import React from 'react';

export const ProgressionListLabel = (props: TypographyProps) => {
  return <Typography {...props} variant="body1" />;
};
